// action
import {
    SAVE_ADMIN_TYPE,
    SAVE_ADMIN_TYPE_FAIL,
    SAVE_ADMIN_TYPE_SUCCESS,
    SAVE_ADMIN_TYPE_RESET
} from '../action/saveAdminTypeAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ADMIN_TYPE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_ADMIN_TYPE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_ADMIN_TYPE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_ADMIN_TYPE_RESET:
            return initialState
        default:
            return state
    }
}